export { Icon } from "./icon";
export type { IconName, IconProps } from "./icon.interface";
